import React from 'react';
import {ReduxNetworkProvider as Provider} from 'react-native-offline';

interface ReduxNetworkProviderProps {
  children: React.ReactNode;
}

const ReduxNetworkProvider: React.FC<ReduxNetworkProviderProps> = ({
  children = null,
}) => {
  return <Provider pingInterval={10000}>{children}</Provider>;
};

export {ReduxNetworkProvider as default};
